// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Satz-Mathe (Stepper), portiert aus docs/referenz/trainingslog.html
import type { SetEntry } from "./types"

export const REP_STEP = 1
export const WEIGHT_STEP = 2.5

/** Stepper-Schritt: min-geklemmt, auf 2 Nachkommastellen gerundet. */
export function step(value: number, delta: number, min = 0): number {
  return Math.max(min, Math.round((value + delta) * 100) / 100)
}

/** Gewicht deutsch formatiert ("22,5"), ganze Zahlen ohne Komma. */
export function fmtWeight(w: number): string {
  return w % 1 ? w.toLocaleString("de-DE") : String(w)
}

/** Gerätearten ohne sinnvolle kg-Angabe (Datenset-Vokabular): Körpergewicht,
    Bänder/Seile, Bälle und Cardiogeräte. Blendet die Gewichtsspalte aus (A3 +
    Thors Feedback Runde 8); „Zusatzgewicht eintragen" bleibt als Ausweg. */
const OHNE_GEWICHT = new Set([
  "body weight", "band", "rope", "assisted", "stability ball", "bosu ball",
  "wheel roller", "elliptical machine", "stationary bike", "skierg machine",
])

/** Übung ohne Gewichtseingabe? (früher nur „body weight") */
export function isBodyweight(equipment: string | undefined): boolean {
  return equipment !== undefined && OHNE_GEWICHT.has(equipment)
}

/** Spalten-Beschriftung: „8–10 Min." / „30 Sek. je Seite" → Zeit statt „Wdh." */
export function repsSpalte(repsText: string | undefined): string {
  if (repsText && /min/i.test(repsText)) return "Min."
  if (repsText && /sek/i.test(repsText)) return "Sek."
  return "Wdh."
}

/** Satz lesbar: „12×20 kg", ohne Gewicht nur „12". */
export function fmtSet(s: SetEntry): string {
  return s.weight_kg ? `${s.reps}×${fmtWeight(s.weight_kg)} kg` : `${s.reps}`
}

/** Volumen = Σ (Wdh. × Gewicht). */
export function volume(sets: SetEntry[]): number {
  return sets.reduce((s, x) => s + (x.reps || 0) * (x.weight_kg || 0), 0)
}

/** Neuer Satz: 10 Wdh., Gewicht vom letzten Satz übernommen. */
export function nextSet(sets: SetEntry[]): SetEntry {
  return { reps: 10, weight_kg: sets.at(-1)?.weight_kg ?? 20 }
}

/** "+ Satz wie zuvor": letzten Satz kopieren. */
export function duplicateLastSet(sets: SetEntry[]): SetEntry {
  const last = sets.at(-1)
  return last ? { ...last } : { reps: 10, weight_kg: 20 }
}

/** Sätze ohne Wiederholungen rausfiltern (Speichern-Validierung). */
export function cleanSets(sets: SetEntry[]): SetEntry[] {
  return sets.filter((s) => (s.reps || 0) > 0).map((s) => ({ reps: +s.reps, weight_kg: +(s.weight_kg || 0) }))
}

export const DEFAULT_SETS: SetEntry[] = [{ reps: 12, weight_kg: 20 }]
